<template>
    <div class="modal" tabindex="-1" aria-modal="true" role="dialog" :style="{ 'display': (isVisible ? 'block' : 'none'), '--tblr-modal-width': width }">
        <div class="modal-background fade show" @click="backdropClick"></div>
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <slot></slot>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "modal",
    props: {
        staticBackdrop: {
            type: Boolean,
            default: false
        },
        width: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            isVisible: false
        };
    },
    methods: {
        backdropClick() {
            if (this.staticBackdrop) {
                return;
            }
            this.close();
        },
        close() {
            if (this.isVisible) {
                this.isVisible = false;
                this.$emit("closed", true);
            }
        },
        open() {
            this.isVisible = true;
            this.$emit("opened", true);
        }
    }
};
</script>
<style lang="scss">
.modal {
    .modal-dialog {
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        display: flex;
        flex-direction: column;
        align-items: stretch;
        justify-content: center;
        box-sizing: border-box;
    }

    .modal-content {
        max-height: 100%;
        overflow: auto;
    }

    .modal-background {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, 0.5);
    }
}
</style>
